import { Injectable } from '@angular/core';
import {MdbModalRef, MdbModalService} from "mdb-angular-ui-kit/modal";
import {ConflictModel} from "../../models/conflict.model";
import {
  HandleUpdateConflictModalComponent
} from "../../components/utils/handle-update-conflict-modal/handle-update-conflict-modal.component";

@Injectable({
  providedIn: 'root'
})
export class SafeUpdateService {
  constructor(private modalService: MdbModalService) {
  }

  openModal(rootConflict: ConflictModel,
            serverModel: any = null,
            updateModel: any = null,
            currentModel: any = null): MdbModalRef<HandleUpdateConflictModalComponent> {
    return this.modalService.open(HandleUpdateConflictModalComponent, {
      modalClass: 'modal-xl',
      ignoreBackdropClick: true,
      data: {
        rootConflict: rootConflict,
        serverModel: serverModel,
        updateModel: updateModel,
        currentModel: currentModel
      },
    });
  }

  handleResource(resource: any, serverResource: any, overrideValues: { [key: string]: any } = {}): any {
    this.deepMerge(serverResource, resource);
    resource = serverResource

    if(Object.keys(overrideValues).length !== 0) {
      Object.keys(overrideValues).forEach(key => {
        this.setNestedValue(resource, key, overrideValues[key]);
      });
    }
    return resource
  }

  private deepMerge(target: any, source: any) {
    Object.keys(source).forEach(key => {
      if(key === "updatedAt")
        return

      if (target.hasOwnProperty(key)) {
        if (
          source[key] !== null && (typeof source[key] === 'object' || Array.isArray(source[key]))
        ) {
          // Recursively merge if it's an object (but not an array)
          if(typeof source[key] !== 'object' || Array.isArray(source[key])) {
            source[key].forEach((s: any, i: number) => {
              this.deepMerge(target[key][i], source[key][i])
            })
          } else
            this.deepMerge(target[key], source[key]);
        } else {
          // Directly assign if it's a primitive value, array, or other types
          target[key] = source[key];
        }
      }
    });
  }

  private setNestedValue(obj: any, keyPath: string, value: any) {
    const keys = keyPath.split('.'); // Split keyPath into parts: ['customer', 'company']
    let current = obj;

    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];

      // Ensure the key exists and is an object, otherwise create an empty object
      if (!current[key] || typeof current[key] !== 'object') {
        current[key] = {};
      }
      current = current[key];
    }

    // Set the final value
    current[keys[keys.length - 1]] = value;
  }
}
